module.exports = __webpack_public_path__ + "static/media/addTruck.f932d232.png";